import(/* webpackMode: "eager" */ "/var/www/nextjs-green/src/app/not-found.tsx");
